<template>
    <div class="legal legal1">
        <div class="wrapper">
            <div class="legal__body">
                <div v-if="vacancy" class="legal">
                    <button class="btn btn-back" @click.prevent="handleBack('/home')">
                        <span>{{ trans.text.pages.back }}</span>
                    </button>

                    <div class="legal__headline">
                        <h5>{{ getTitle }}</h5>
                    </div>

                    <div v-if="vacancy.short_description" class="legal__sub-line">
                        <div v-html="getShortDescription"></div>
                    </div>

                    <div
                        class="legal__content"
                        v-html="getContent">
                    </div>

                    <yandex-share
                        :services="['facebook', 'linkedin','telegram','whatsapp']"
                        class="social-wrap"
                        counter
                    />

                    <cv-form
                        v-if="departments.length > 0"
                        :departments="departments"
                        :departmentsForSelect="departments"
                        :lang="lang"
                        :vacancy="vacancy"
                        :title="'Apply now'"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import YandexShare from '@cookieseater/vue-yandex-share';

export default {
    props: ['vacancy', 'departments', 'lang', 'trans', 'departments'],
    components: {YandexShare},
    name: "VacancyComponent",
    data() {
        return {
            fromRoute: null
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fromRoute = from;
        })
    },
    computed: {
        getTitle() {
            return this.vacancy.title;
        },
        getContent() {
            return this.vacancy.description;
        },
        getShortDescription() {
            return this.vacancy.short_description;
        }
    },
    methods: {
        handleBack(fallback) {
            if (history.length === 1) {
                location.href = `/${this.lang}${fallback}`;
            } else {
                history.back()
            }
        }
    }
}
</script>

<style scoped>
    .legal{
        margin-bottom: 128px;
    }
    .legal__headline h5 {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 36px;
    line-height: 37px;
}

.legal__sub-line {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: #A3A3A3;
    margin-bottom: 65px;
}

.legal__content {
    font-weight: normal;
    font-size: 17px;
    line-height: 28px;
    color: #1C1C1C;
    margin-bottom: 64px;
}
.social-wrap{
    margin-bottom: 64px;
}

.legal__content p {
    margin-bottom: 25px;
}

.legal__content p:last-of-type {
    margin-bottom: 0;
}
</style>
